<template>
  <div class="productBigImg product-big-img">
    <a class="product-big-img__img-wrapper" @click="() => $emit('hideBigImg')">
      <v-lazy-img
        class="product-big-img__img"
        :src="bigImgGallery[index] ? bigImgGallery[index].thumbnail : ''"
        :data-url="bigImgGallery[index] ? bigImgGallery[index].url: ''"
      />
    </a>
    <span class="iconfont icon-cm-cancel-1-copy cancel" @click="() => $emit('hideBigImg')"></span>
    <span
      class="iconfont icon-cm-web__bitebizuojiantou left_arrow"
      @click.stop="toggleindex(1)"
      v-show="this.bigImgGallery.length>1"
    ></span>
    <span
      class="iconfont icon-cm-web__bitebiyoujiantou right_arrow"
      @click.stop="toggleindex(0)"
      v-show="this.bigImgGallery.length>1"
    ></span>
  </div>
</template>
<script>
export default {
  props: ["bigImgGallery", "bigImgGalleryIndex"],
  data() {
    return {
      index: this.bigImgGalleryIndex || 0 
    };
  },
  emits: ['hideBigImg', 'changeBigImgIndex'],
  methods: {
    toggleindex(e) {
      if (e) {
        let num = this.index - 1;

        if (num < 0) {
          num = this.bigImgGallery.length - 1
        }
        this.index = num
      } else {
        let num = this.index + 1;
        if (num >= this.bigImgGallery?.length) {
          num = 0;
        }
        this.index = num;
      }

      this.$emit('changeBigImgIndex', this.index)
    }
  },
};
</script>
<style scoped lang='scss'>
.product-big-img {
  display: flex;
  align-items: center;
  justify-content: center;
  &__img {
    max-height: 100vh;
    max-width: 100vw;
    width: 600px;
    object-fit: contain;
    cursor: zoom-out;
  }
}
.productBigImg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  z-index: 99999;
  span {
    cursor: pointer;
    position: absolute;
    font-size: 24px;
    color: #333;
    font-weight: 700;
    padding: 10px;
  }
  .cancel {
    top: 20px;
    right: 20px;
  }
  .left_arrow {
    top: 50%;
    left: 20px;
    font-weight: 400;
  }
  .right_arrow {
    top: 50%;
    right: 20px;
    font-weight: 400;
  }
}
</style>